import { combineReducers } from 'redux-immutable';

import form from '../Form/reducer';
import isLoading from '../LoadingScreen/reducer';
import entities from '../entities/reducer';
import notifications from '../components/Notifications/reducer';
import Customers from '../Customers/reducer';
import Resources from '../Resources/reducer';
import PersistedState from '../containers/withPersistedState/reducer';
import ReduxState from '../containers/withReduxState/reducer';
import ResourcesSchedule from '../Resources/Schedule/reducer';
import * as SessionActions from '../entities/Session/actions';

const baseReducer = combineReducers({
  ...entities,
  Customers,
  Resources,
  notifications,
  isLoading,
  form,
  PersistedState,
  ReduxState,
  ResourcesSchedule,
});

const DEAUTH_WHITELIST_KEY_PATHS = ['routing', 'isLoading', 'notifications', 'session', 'support'];
export default function authenticationAwareReducer(state, action) {
  if (action.type === SessionActions.DEAUTH.REQUEST) {
    const whitelistedState =
      DEAUTH_WHITELIST_KEY_PATHS.filter((value, key) =>
        DEAUTH_WHITELIST_KEY_PATHS.includes(key));
    return baseReducer(
      undefined,
      action,
    ).merge(whitelistedState);
  }
  return baseReducer(state, action);
}
